(function(){
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = 'ontouchstart' in window;
  var hasIO = 'IntersectionObserver' in window;

  /* ① 慣性スクロール（デスクトップのみ）
     ※ ページの高さは画像・動画・Instagramの読込後に伸びるので、
        resize() を逐次呼ばないとスクロールできる範囲が古いままになり、
        ページ下部（フッター）に到達できなくなる */
  if(!reduce && !isTouch && window.Lenis){
    try{
      document.documentElement.classList.add('nc2-lenis');
      var lenis = new Lenis({duration:1.1, smoothWheel:true});
      (function raf(t){ lenis.raf(t); requestAnimationFrame(raf); })();

      var resize = function(){ try{ lenis.resize(); }catch(e){} };
      addEventListener('load', resize);
      addEventListener('resize', resize);
      addEventListener('orientationchange', resize);
      document.addEventListener('shopify:section:load', resize);
      if('ResizeObserver' in window){
        try{ new ResizeObserver(resize).observe(document.body); }catch(e){}
      }
      [300, 1000, 2500, 5000].forEach(function(ms){ setTimeout(resize, ms); });

      /* 安全装置：ホイールしてもページが動かない状態が続いたら
         慣性スクロールを破棄してブラウザ標準のスクロールに戻す。
         何が起きてもページ末尾に到達できない状態を残さないための保険。 */
      var strikes = 0;
      addEventListener('wheel', function(e){
        if(!lenis) return;
        var max = document.documentElement.scrollHeight - innerHeight;
        var room = e.deltaY > 0 ? (max - scrollY) : scrollY;
        if(room < 20) return; /* 上下の端では判定しない */
        var y0 = scrollY;
        setTimeout(function(){
          if(Math.abs(scrollY - y0) < 1){
            strikes++;
            if(strikes >= 3){
              try{ lenis.destroy(); }catch(e){}
              lenis = null;
              document.documentElement.classList.remove('nc2-lenis','lenis','lenis-smooth','lenis-scrolling');
            }
          } else { strikes = 0; }
        }, 700);
      }, {passive:true});
    }catch(e){}
  }

  /* ① 画像のマスクリビール（JSが動いたときだけ有効化。万一の保険で強制表示もあり） */
  if(!reduce && hasIO){
    document.documentElement.classList.add('nc2-motion');
    var targets = document.querySelectorAll('.nc2-story .ph, .nc2-ing-card, .nc2-prod .ph');
    targets.forEach(function(el){ el.classList.add('nc2-reveal'); });
    var rio = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('nc2-open'); rio.unobserve(e.target); } });
    }, {threshold:.15});
    targets.forEach(function(el){ rio.observe(el); });
    /* 保険：4秒後には必ず全部開く */
    setTimeout(function(){ targets.forEach(function(el){ el.classList.add('nc2-open'); }); }, 4000);
  }

  /* ② 数字のカウントアップ */
  if(!reduce && hasIO){
    var cio = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        cio.unobserve(e.target);
        var v = e.target, n = parseInt(v.getAttribute('data-nc2count'), 10), t0 = null, dur = 1300;
        function step(ts){
          if(!t0) t0 = ts;
          var p = Math.min((ts - t0)/dur, 1); p = 1 - Math.pow(1 - p, 3);
          v.firstChild.nodeValue = String(Math.round(n * p));
          if(p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, {threshold:.6});
    document.querySelectorAll('.nc2-num .v').forEach(function(v){
      var t = (v.childNodes[0] && v.childNodes[0].nodeValue || '').trim();
      if(/^\d+$/.test(t)){ v.setAttribute('data-nc2count', t); v.firstChild.nodeValue = '0'; cio.observe(v); }
    });
  }

  /* ①② ヒーローコピーのパララックス＋ストーリー写真の視差 */
  if(!reduce){
    var copy = document.querySelector('.nc2-hero-copy');
    var storyImgs = Array.prototype.slice.call(document.querySelectorAll('.nc2-story .ph img'));
    var ticking = false;
    function onScroll(){
      if(ticking) return; ticking = true;
      requestAnimationFrame(function(){
        var y = window.scrollY, vh = window.innerHeight;
        if(copy && y < vh * 1.2){
          copy.style.transform = 'translateY(' + (y * 0.28) + 'px)';
          copy.style.opacity = Math.max(1 - y/(vh * 0.85), 0);
        }
        storyImgs.forEach(function(img){
          var r = img.parentElement.getBoundingClientRect();
          if(r.bottom > 0 && r.top < vh){
            img.style.transform = 'scale(1.07) translateY(' + ((r.top + r.height/2 - vh/2) * -0.045) + 'px)';
          }
        });
        ticking = false;
      });
    }
    addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }
})();